import { isNotFound, useRouteContext } from '@tanstack/react-router';
import { Skeleton } from '@worldcoo/ui/components/skeleton';
import { Suspense } from 'react';
import { Image } from '../../-components/image';
import { usePortalAuthorQuery } from '@/lib/queries-portal';
import { getLogoImageSize } from '@/lib/shared';
import { usePortalDisplayContext } from './portal-display-context';

export function Logo() {
	const portalData = usePortalDisplayContext();
	if (portalData) {
		return portalData.logoUrl ? (
			<Image
				src={portalData.logoUrl}
				alt="Portal Logo"
				height={56}
				aspectRatio={2}
				objectFit="contain"
				className="aspect-auto! max-h-14"
			/>
		) : null;
	}
	return <PortalLogo />;
}

function PortalLogo() {
	const { portalId } = useRouteContext({ from: '__root__' });

	return (
		<Suspense fallback={<Skeleton className="bg-secondary" style={{ height: getLogoImageSize(portalId).height }} />}>
			<SuspensedLogo />
		</Suspense>
	);
}

function SuspensedLogo() {
	const { portalId } = useRouteContext({ from: '__root__' });
	const author = usePortalAuthorQuery();

	if (isNotFound(author) || !author.logo) return;

	return (
		<Image
			src={author.logo.location}
			alt="Portal Logo"
			height={getLogoImageSize(portalId).height}
			// TODO: there is a lot of logos that doesn't have sizes defined, fix that
			aspectRatio={
				(author.logo.width && author.logo.height ? author.logo.width / author.logo.height : undefined) as number
			}
			priority
			// The aspect ratio defined above could deform the image, so we force it to auto
			className="aspect-auto!"
		/>
	);
}
